<template>
  <div class="airDetails">
    <div class="Details_data" v-if="detailData">
      <h5>
        创建时间: {{detailData.orderTime}}
      </h5>
      <div class="Details_text df">
        <span>
          订单号 :  {{orderNo}}
        </span>
        <span v-if="flightType === '1'">
          订单类型 : 单程
        </span>
        <span v-if="flightType === '2'">
          订单类型 : 往返
        </span>
        <span v-if="flightType === '3'">
          订单类型 : 多程
        </span>
        <span>
          订单状态 : {{detailData.orderStatusText}}
        </span>
        <span>
          出票时间 : {{detailData.ticketTime ? detailData.ticketTime : ''}}
        </span>
        <span>
          票面总价 : {{detailData.totalAmount}}
        </span>
      </div>
    </div>
    <div class="passenger">
      <h2>
        <p>航班信息</p>
      </h2>
      <el-row type="flex" class="passenger_top">
        <el-col :span='4'>
          乘客姓名
        </el-col> 
        <el-col :span='4'>
          乘客类型
        </el-col>
        <el-col :span='6'>
          证件号码
        </el-col>
        <el-col :span='4'>
          出生年月
        </el-col>
        <el-col :span='6'>
          票号
        </el-col>
      </el-row>
      <div class="passenger_body" v-for="(item,index) in passengers" :key="index">
        <div class="passengerD">
          <el-col :span='4'>
            <el-checkbox :value="item.inputC" @change='getName(item)'>
            </el-checkbox>
             {{item.psgName}}
          </el-col>
          <el-col :span='4'>
            <span v-if="item.psgType === '1'">
              成人
            </span>
            <span v-if="item.psgType === '2'">
              儿童
            </span>
            <span v-if="item.psgType === '3'">
              婴儿
            </span>
          </el-col>
          <el-col :span='6'>
            {{item.cardNo}}
          </el-col>
          <el-col :span='4'>
            {{item.birthday}}
          </el-col>
          <el-col :span='6'>
            {{item.ticketNumber}} 
          </el-col>
        </div>
        <div class="airList_Top">
              <el-col :span="4">
                航班号
              </el-col>
              <el-col :span="3">
                航空公司
              </el-col>
              <el-col :span="3">
                航班日期
              </el-col>
              <el-col :span="4">
                出发地
              </el-col>
              <el-col :span="4">
                到达地
              </el-col>
              <el-col :span="2">
                舱位
              </el-col>
              <el-col :span="4">
                状态
              </el-col>
            </div>
        <div class="" v-for="(childItem,childIndex) in item.segments" :key="childIndex">
          <div class="airList">
            <div class="changingData">
              <el-col :span="4">
                <!-- <input type="text" v-model="childItem.flightNo" :placeholder="childItem.flightNo" v-if='childItem.inputC'> -->
                <!-- <p v-else> -->
                  {{childItem.flightNo}}
                <!-- </p> -->
              </el-col>
              <el-col :span="3">
                {{childItem.airlineName}}
              </el-col>
              <el-col :span="3">
                <!-- <el-date-picker
                  class="time"
                  v-model="childItem.beginDate"
                  type="date"
                  clear-icon
                  v-if="childItem.inputC"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker> -->
                <p >
                  {{childItem.beginDate}}
                </p>
              </el-col>
              <el-col :span="4">
                {{childItem.sCityName}}({{childItem.sCityCode}})
              </el-col>
              <el-col :span="4">
                {{childItem.eCityName}}({{childItem.eCityCode}})
              </el-col>
              <el-col :span="2">
                <!-- <input type="text" v-model="childItem.cabin" :placeholder="childItem.cabin" v-if='childItem.inputC'> -->
                <p>
                  {{childItem.cabin}}
                </p>
              </el-col>
              <el-col :span="4">
                <el-checkbox v-if="childItem.status === '1' || childItem.status === '2'" :value="childItem.inputC" @change='getsegments(childItem.airlineId,childItem)' disabled>
                </el-checkbox>
                <span>
                  {{childItem.statusText}}
                </span>
              </el-col>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="Data_box">
      <h2>
        <p>改签操作</p>
      </h2>
      <div class="dishonour_type df">
        <div class="df typeSelect font-13">
          <p>
            退票说明:
            <textarea v-model="remark"></textarea>
          </p>
          <!-- <select v-model="dishonourType" >
            <option
              label="请选择"
              :value="'请选择'">
            </option>
            <option
              label="自愿改签"
              :value="1">
            </option>
            <option
              label="非自愿改签"
              :value="2">
            </option>
          </select> -->

        </div>
        <!-- <div class="df">
          <p>
            退票备注:
          </p>
          <textarea>
          </textarea>
        </div> -->
        <button @click="getDishonour()">
          申请退票
        </button>
      </div>
    </div>
  </div>
</template>
<script>
// 订单查询
const detail = require(`@/lib/data-service/flight/flight_domestic_buyer_manage_order_detail`);
const refund = require(`@/lib/data-service/flight/flight_domestic_buyer_white_order_refund`);
  export default {
    data () {
      return {
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 1000 * 3600 * 24;
          },
          shortcuts: [
            {
              text: '今天',
              onClick(picker) {
                picker.$emit('pick', new Date());
              }
            }
          ]
        },
        detailData: null,
        orderNo: '',
        orderStatus: '',
        beginDate: '',
        orderStatusText: '',
        flightType: '1',
        passengers: [],
        changeType: 1,
        dishonourId: [],
        cabinCode: '',
        remark: ''
      }
    },
    methods: {
      // GetdetailData () {
      //   detail({orderNo: this.orderNo}).then( res => {
      //     console.log(res)
      //     this.detailData = res.detail
      //     this.flightType = res.detail.flightType
      //     this.$forceUpdate();
      //   })
      // }
      getsegments(id,inputType) {
        inputType.inputC = !inputType.inputC
        console.log(id,inputType)
        this.$forceUpdate();
      },
      getName(item) {
        console.log(item)
        item.inputC = !item.inputC
        for (let i = 0; i < item.segments.length; i++) {
          if(item.segments[i].status === '1' || item.segments[i].status === '2') {
            item.segments[i].inputC = item.inputC
            this.$forceUpdate();
          }
        }
      },
      getDishonour () {
        this.dishonourId = []
        for (let i = 0; i < this.passengers.length; i++) {
          for (let j = 0; j < this.passengers[i].segments.length; j++) {
            if(this.passengers[i].segments[j].inputC === true) {
              this.dishonourId.push(this.passengers[i].segments[j].airlineId)
            }
          }
        }
        if(this.dishonourId.length === 0) {
          return this.$message({
            message: "请选择需要改签的乘客",
            type: "error"
          });
        }
        let lineId = this.dishonourId.join()
        console.log(this.dishonourId)
        let params = {
          lineId,
          orderNo: this.orderNo,
          refundType: '1',
          remark: this.remark
        }
        console.log(params)
        refund(params).then(res => {
          console.log(res)
          this.$router.go(-1);
        }).catch(err => {
          return this.$message({
            message: err,
            type: "error"
          });
        })
      }
    },
    created () {
      if (this.$route.query.ordersNo) {
        this.orderNo = this.$route.query.ordersNo
        this.orderStatus = this.$route.query.orderStatus
        this.orderStatusText = this.$route.query.orderStatusText
        detail({orderNo: this.orderNo}).then( res => {
          console.log(res)
          this.detailData = res.detail
          this.flightType = res.detail.flightType
          this.passengers = res.detail.passengers
          for (let i = 0; i < this.passengers.length; i++) {
            this.passengers[i].inputC = false
            for (let j = 0; j < this.passengers[i].segments.length; j++) {
              this.passengers[i].segments[j].inputC = false
            }
          }
          console.log(1111)
          this.$forceUpdate();
        })
      }
    }
  }
</script>
<style lang="less" scoped>
.airDetails {
  width: 100%;
}
.df {
  display: flex;
}
.Details_data {
  background: #fffcfa;
	border: solid 1px #ffb27f;
  h5 {
    padding-left: 30px;
    font-size: 12px;
	  color: #666666;
    line-height: 32px;
    height: 32px;
    background: #fff5ef;
  }
  .Details_text {
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 30px;
    span {
      display: inline-block;
      width: 33%;
      font-size: 14px;
      color: #666;
      line-height: 25px;
      height:25px
    }
  }
}
.passenger, .Data_box{
  border: 1px solid #e9e9e9;
  margin-bottom: 20px;
  margin-top: 20px;
  h2 {
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    background: #237dc8;
    color: #4b4b4b;
    padding-left: 8px;
    p {
      background-color: #ecf6ff;
      vertical-align: middle;
      padding-left: 20px;
    }
  }
  .passenger_top{
    padding: 0 15px;
    text-align: center;
    background: #f1f3f5;
    color: #666;
    line-height: 25px;
    font-size: 14px;
  }
  .passenger_body {
    padding: 0 15px 15px;
  }
  .time {
    width: 100px;
    .el-input__inner {
      padding: 0;
    }
    .el-input__prefix {
      display: none;
    }
  }
  .passengerD {
    height: 40px;
    background: #fff;
    font-size: 14px;
    line-height: 40px;
    text-align: center;
    border-top: 1px solid #ececec;
    &:nth-child(1) {
      border-top: none;
    }
    >div {
      height: 40px;
    }
  }
  
  .airList {
    border-top: 1px dashed #e9e9e9;
  }
  .airList_Top {
    background: #ecf6ff;
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    text-align: center;
  }
  .airList {
    font-size: 12px;
    text-align: center;
    color: #999;
  }
  .changingData {
    height: 50px;
    padding: 5px 0;
    >div {
      height: 40px;
      line-height: 40px;
    }
    input {
      width: 100px;
      border: 1px solid #DCDFE6;
      text-align: center;
      padding: 0 10px;
      box-sizing: border-box;
      border-radius: 5px;
      height: 100%;
    }
  }
  .Data {
    color: #237dc8;
    cursor: pointer;
  }
}
.dishonour_type {
  padding: 25px;
  justify-content: space-between;
  p {
    margin-top: 10px;
    margin-right: 15px;
    /deep/.el-radio-group {
      margin-left: 20px;
    }
    /deep/.el-input {
      margin-left: 20px;
    }
    textarea {
      margin-left: 20px;
      vertical-align: top;
      width: 500px;
      height: 100px;
      border-radius: 5px;
      border: 1px solid #e9e9e9;
    }
  }
  .typeSelect {
    align-items: center;
  }
  select {
    width: 202px;
    padding-left: 10px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #DCDFE6;
    border-radius: 5px;
    outline: none;
  }

  button {
    outline: none;
    width: 90px;
    height: 35px;
    line-height: 35px;
    background: #378ded;
    border: none;
    color: #fff;
    cursor: pointer;
  }
}
</style>
